import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=6318b649&scoped=true&"
import script from "./BackLink.vue?vue&type=script&lang=js&"
export * from "./BackLink.vue?vue&type=script&lang=js&"
import style0 from "./BackLink.vue?vue&type=style&index=0&id=6318b649&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318b649",
  null
  
)

export default component.exports